import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import ThemeContext from '../../contexts/themeContext';
import USERS from '../../common/data/userDummyData';
import { extraMenu } from '../../menu';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../components/bootstrap/Dropdown';
import Button from '../../components/bootstrap/Button';
import { useMst } from '../../models';
import { useTranslation } from 'react-i18next';
import { getPersonDisplayName } from 'helpers/personNameI18n';
import { getLocalizedFieldOrI18n } from 'helpers/localizedField';
import { removeItem } from '../../lib/localstorage';
import AuthService from '../../services/AuthService';
import { observer } from 'mobx-react';
import Avatar from '../../components/Avatar';
import { moveLoginPage } from '../../lib/Util';
import userImg from '../../assets/img/img_profile.png';
import PasswordModal from 'pages/common/Headers/components/PasswordModal';
import SettingModal from 'pages/common/Headers/components/SettingModal';

export const UserAvatar = ({ srcSet, src }) => {
    return (
        <div className='user-avatar'>
            <img
                srcSet={srcSet}
                src={src}
                alt='Avatar'
                width={128}
                height={128}
                onError={`this.src='${USERS.SAM.srcSet}'`}
            />
        </div>
    );
};
UserAvatar.propTypes = {
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
};
UserAvatar.defaultProps = {
    srcSet: null,
};

const User = observer(() => {
    const { user, company } = useMst();
    const { t, i18n } = useTranslation();
    const { mobileDesign } = useContext(ThemeContext);
    const [isPasswordPopOpen, setIsPasswordPopOpen] = useState(false);
    const [isSettingPopOpen, setIsSettingPopOpen] = useState(false);

    const userInfo = (
        <div className='user rounded'>
            <Avatar
                src={user.me.profile || userImg}
                userName={`${company?.nickName || user?.name || ''}`}
                size={30}
                color={'#6B88EA'}
                textSizeRatio={10}
                maxInitials={2}
                fgColor={'light'}
                className='user_thumb'
            />
            <div className='user-info'>
                <div className='user-name'>
                    {getPersonDisplayName(user, i18n.language, `${company?.nickName || user?.name || ''}`)}
                </div>
                {mobileDesign ? (
                    (company?.userRank || user?.me?.userRank) && (
                        <div className='user-sub-title'>
                            {(user?.me?.userRank && getLocalizedFieldOrI18n(user.me, 'userRank')) || t(company?.userRank) || ''}
                        </div>
                    )
                ) : (
                    (company?.userDepartment || user?.me?.userDepartment) && (
                        <div className='user-sub-title'>
                            {(user?.me?.userDepartment && getLocalizedFieldOrI18n(user.me, 'userDepartment')) || company?.userDepartment}
                        </div>
                    )
                )}
            </div>
        </div>
    )

    // [PC]: 드롭다운 제외
    if(!mobileDesign){
        return <div className='nav-user-wrap'>{userInfo}</div>
    }

    return (
        <>
        {/* [MO]: 드롭다운 포함 */}
        {mobileDesign &&
        <Dropdown className='nav-user-wrap'>
            <DropdownToggle hasIcon={false}>
                {userInfo}
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem>
                    <Button
                        className='btn_setting'
                        icon='GearFill'
                        onClick={() => setIsSettingPopOpen(true)}
                    >{t('설정')}</Button>
                </DropdownItem>
                <DropdownItem isDivider />
                <DropdownItem>
                    <Button
                        className='btn_pw'
                        onClick={() => setIsPasswordPopOpen(true)}
                    >{t('비밀번호 변경')}</Button>
                </DropdownItem>
                <DropdownItem isDivider />
                <DropdownItem>
                    <Button
                        className='btn_logout'
                        onClick={async () => {
                            AuthService.logout().then(async () => {
                                await Promise.all([
                                    removeItem('access-token'),
                                    removeItem('refresh-token'),
                                    removeItem('rootState'),
                                    removeItem('webToken'),
                                    removeItem('authUser'),
                                    user.logout(),
                                    company.logout(),
                                ]).then(() => {
                                    moveLoginPage();
                                });
                            });
                        }}
                    >
                        {t('로그아웃')}
                    </Button>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>}

        {/************* 모달 **************/}
        {/* 비밀번호 변경 */}
        <PasswordModal isPasswordPopOpen={isPasswordPopOpen} setIsPasswordPopOpen={setIsPasswordPopOpen} />
        {/* 설정 */}
        <SettingModal isSettingPopOpen={isSettingPopOpen} setIsSettingPopOpen={setIsSettingPopOpen} />
        </>
    );
});

export default User;
